<template>
  <div class="main">
    <div class="main_top">
      <img src="@/assets/logo.png" alt="">
      <img src="@/assets/logo_txt.png" alt="">
      <span>{{ t('index.title') }}</span>
      <div class="btn_group">
        <div @click="handleLang('zh-CN')">
          <span>中文</span>
        </div>
        <div @click="handleLang('en-US')">
          <span>English</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { setLocale } from '@/locales';

const router = useRouter();
const { t } = useI18n();

const handleLang = (lang) => {
  setLocale(lang);
  router.push('/home');
}

onMounted(() => {
  console.log('mounted')
})
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  .main_top {
    display: flex;
    flex-direction: column;
    align-items: center;

    >img:nth-child(1) {
      width: 148.5px;
      height: 106.2px;
      margin-bottom: 48px;
    }

    >img:nth-child(2) {
      width: 386px;
      object-fit: contain;
      margin-bottom: 44px;
    }

    >span {
      font-weight: bold;
      font-size: 32px;
      color: #0A0A0A;
      margin-bottom: 50px;
    }

    .btn_group {
      width: 100vw;
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      gap: 37px;

      div {
        width: 338px;
        height: 140px;
        background: linear-gradient(-4deg, #E7EFFF, #FFFFFF);
        border-radius: 20px;
        border: 1px solid #C5CCE8;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        span {
          font-weight: bold;
          font-size: 26px;
          line-height: 77px;
          background: linear-gradient(166deg, #306BFD 0%, #9469FE 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          user-select: none;
        }
      }
    }
  }
}
</style>
